<template>
  <div>
    <template v-if="didUserJustLoginOrSignup">
      <b-headline type="h1" typography="h15" class="mb-8" v-html="$t('headlineUserJustLoginOrSignup')" />

      <div v-html="$t('userJustLoginOrSignup')" class="text-base l:text-xl mb-8" />
    </template>
    <template v-else>
      <b-headline type="h1" typography="h15" class="mb-8" v-html="$t('headline')" />
      <p class="mb-8 text-base l:text-xl">
        {{ $t("main", { totalBooks: $options.totalBooks }) }}
      </p>
    </template>
  </div>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import globals from "@/utils/globals"

export default {
  name: "CopySection",
  totalBooks: globals.totalBooks,
  components: {
    BHeadline
  },
  props: {
    isUserLoggedIn: {
      default: false,
      type: Boolean
    },
    didUserJustLoginOrSignup: {
      default: false,
      type: Boolean
    }
  },
  i18n: {
    messages: {
      en: {
        headlineUserJustLoginOrSignup: "Almost there!<br>Accept your invite to get started.",
        userJustLoginOrSignup:
          "Accept the invite, and <strong>join your friend</strong> on their Blinkist Premium subscription, with a separate <strong>account of your own.</strong><br><br>Blinkist is the world’s leading app for understanding powerful ideas through 15-minute audio and text explainers on thousands of nonfiction books and podcasts.",
        headline: "Your friend has invited you to join Blinkist!",
        main: "Join your friend on their Blinkist Premium plan, with a separate account of your own. The best part? It's already covered because your account is part of their subscription!"
      },
      de: {
        headlineUserJustLoginOrSignup: "Fast geschafft!<br>Einfach die Einladung annehmen, um loszulegen.",
        userJustLoginOrSignup:
          "Akzeptiere die Einladung und schließe dich dem Premium-Abo deines Freundes oder deiner Freundin an – mit einem separaten Account für dich allein.<br><br>Blinkist ist die weltweit führende Wissens-App mit Tausenden von Sachbüchern und Podcasts im Kurzformat. In nur 15 Minuten gelesen oder angehört, kannst du dich überall und jederzeit weiterbilden.",
        headline: "Du wurdest zu Blinkist eingeladen!",
        main: "Du bekommst ein eigenes Premium-Konto und kannst auf die gesamte Blinkist Bibliothek mit mehr als {totalBooks} Highlights aus Sachbüchern & Podcasts zugreifen. Das Ganze ist kostenlos für dich: Dein Konto ist Teil des Abos der Person, die dich eingeladen hat."
      }
    }
  }
}
</script>
